export default {
  Appointment: 'Appointment',
  TimeLock: 'TimeLock',
}
